import React, {PureComponent} from 'react';
import moment from 'moment'
import {Card, CardBody, CardHeader, Col, Container, Row} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import FeedbackReport from "./FeedbackReport";
import {Icons} from "../../../Events/AssetEvents/components/Icons";
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';

import { loadFeatureImage } from "../../../../redux/actions/reportAction";
import {loadEventHistory, createEventFeedback} from "../../../../redux/actions/eventManagement";

const style = {
    bottom: 300
};
const rulColor = '#fd8b74';
const healthColor = '#63c9af';
const newnessColor = '#5e8ba3';

const event_payload = [
        { id: 'severity', value: 'Severity', type: 'rect', color: rulColor},
        { id: 'newness', value: 'Newness', type: 'rect', color: newnessColor},
    ];


class EditFeedbackReport extends PureComponent{
    constructor(props) {
        super(props);
        this.state = {
            defaultImage: '/asset_health_page/feature_image1.jpg',
        };
        this.handleCreate = this.handleCreate.bind(this);
        this.closeForm = this.closeForm.bind(this);
    }

    componentDidMount() {
        let { selectedFeedbackReport, loadEventHistory,   loadFeatureImage } = this.props;

        if(!selectedFeedbackReport){
            this.props.history.push('/asset_events');
        } else{
            let event_id = selectedFeedbackReport._id;
            loadEventHistory({event_id});
        }
    }

    handleCreate = dataObj => {
        const data = JSON.parse(JSON.stringify(dataObj));
        if ( data && Object.keys(data).length > 0 ) {
            console.log("feedback created");
            console.log(data);
            data.ai_decision_quality = data.ai_decision_quality.value;
            data.corrected_event_type = data.corrected_event_type.value
            data.corrected_label = data.corrected_label.value
            data.corrected_severity = data.corrected_severity.value
            this.props.createEventFeedback(data);
            this.props.history.push('/asset_events');
        }
    };

    closeForm = () => {
        console.log("closing form");
        this.props.history.push('/asset_events');
    };


    loadEventChartImage = (val) => {
        const {historyReport } = this.props;
        let imgPath = `${val.payload.location}`;
        console.log("loading image from: ");
        console.log(imgPath);
        this.props.loadFeatureImage(historyReport, imgPath);
    };

    LoadingImage = () =>(
        <div className="col-lg-12 loading text-center col-xs-12 col-sm-12">
            <i className="fa fa-spinner"></i> Loading image
        </div>
    );

    LoadingHistory = () =>(
        <div className="col-lg-12 loading text-center col-xs-12 col-sm-12">
            <i className="fa fa-spinner"></i> Loading History Data
        </div>
    );

    formatTimeline =(tickTime)  => {
        return moment.unix(tickTime).format('MM-DD-YYYY');
    }

    formatTooltipTimeline =(tickTime)  => {
        return "Timestamp: " + moment.unix(tickTime).format('MM-DD-YYYY');
    }


    customTooltip = ({ active, payload, label }) => {
      if (active && payload.length >0) {
        console.log(payload);
        let newness = null;
        let severity= null;
        let flabel = this.formatTimeline(label);
        newness =payload[0].payload.newness
        severity =payload[0].payload.severity
        return (
            <Card className={'assets-report-class'}>
              <CardHeader>
                  <div >
                    <p className="label">{`Timestamp: ${flabel}`}</p>
                    <p className="label">{`Newness: ${newness}`}</p>
                    <p className="label">{`Severity: ${severity}`}</p>
                  </div>
              </CardHeader>
            </Card>
        );
      }
      return null;
    };

    prepareFormData = (selectedFeedbackReport) =>{
        let formData = {};
        formData.event_id = selectedFeedbackReport && selectedFeedbackReport._id;
        formData.event_type = selectedFeedbackReport && selectedFeedbackReport.event_type;
        let etype = selectedFeedbackReport && selectedFeedbackReport.event_type;
        let elabel = selectedFeedbackReport && selectedFeedbackReport.event_label;
        let esev = selectedFeedbackReport && selectedFeedbackReport.severity;
        let cevent_type = {"value":etype, "label":etype};
        formData.corrected_event_type = cevent_type;
        let cevent_label = {"value":elabel, "label":elabel};
        formData.corrected_label = cevent_label;
        let cevent_severity = {"value":esev, "label":esev};
        formData.corrected_severity = cevent_severity;

        return formData;
    }

    render() {
        const { selectedFeedbackReport,  featureImage, featureImageLoading, historyReport,labelManager } = this.props;
        let historyLoaded = false;
        let rulReport = false
        if (historyReport){
            historyLoaded = true;
            console.log("Got history data");
        }

        const formData = this.prepareFormData(selectedFeedbackReport);


        const AxisLabel = ({ axisType, x, y, width, height, stroke, children }) => {
            const isVert = axisType === 'yAxis';
            const cx = isVert ? x : x + (width / 2);
            const cy = isVert ? (height / 2) + y : y + height + 10;
            const rot = isVert ? `270 ${cx} ${cy}` : 0;
            return (
                <text x={cx} y={cy} transform={`rotate(${rot})`} textAnchor="middle" stroke={stroke}>
                    {children}
                </text>
            );
        };

        function severityLabel (val) {
            let color = '';
            switch (val) {
                case 'CRITICAL' :
                    color = '';
                    break;
                case 'MAJOR' :
                    color = 'orange';
                    break;
                case 'MINOR' :
                    color = 'yellow';
                    break;
                case 'NORMAL' :
                    color = 'green';
                    break;
                default:
                    color = '';
            }
            return color;
        }

        return (
            <Container >
                <Row>
                    <Col md={12}>
                        <h3 className="page-title"> Event Action & Feedback</h3>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card className={'assets-report-class'}>
                                <CardHeader>
                                    <Row>
                                        <Col md={12}>
                                            Event Details
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody className={'rm-padd'}>
                                    <Row>
                                        <Col>
                                            <div className="table-responsive assetsEventReportTable">
                                                <table className="table table-hover">
                                                    <thead className="tableHeader">
                                                        <tr>
                                                            <th>EVENT TYPE</th>
                                                            <th>ASSET NAME</th>
                                                            <th>COMPONENT NAME</th>
                                                            <th>COMPONENT TYPE</th>
                                                            <th>EVENT LABEL</th>
                                                            <th>SEVERITY</th>
                                                            <th>AI CONFIDENCE</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        selectedFeedbackReport && Object.keys(selectedFeedbackReport).length > 0 &&
                                                        <tr className="trClassFormat">
                                                            <td tabIndex="1" className="event-status-pending"
                                                            >
                                                                <span>
                                                                    <Icons name={selectedFeedbackReport.event_type} />
                                                                </span>
                                                                {selectedFeedbackReport.event_type}
                                                            </td>
                                                             <td tabIndex="2" className="" >
                                                                {selectedFeedbackReport.parent_source_name}
                                                            </td>
                                                            <td tabIndex="2" className="" >
                                                                {selectedFeedbackReport.source_name}
                                                            </td>
                                                            <td tabIndex="3" className="" >
                                                                <b>{selectedFeedbackReport.source_type_name}</b>
                                                            </td>
                                                            <td tabIndex="4" className="" >
                                                                {selectedFeedbackReport.event_label}
                                                            </td>
                                                            <td tabIndex="5" className="" >
                                                                <mark className={severityLabel(selectedFeedbackReport.severity)}>{selectedFeedbackReport.severity}</mark>
                                                            </td>
                                                            <td tabIndex="6" className="" >
                                                                <div
                                                                    className={
                                                                        selectedFeedbackReport.last_ai_confidence==='LOW'?'red-circle':'green-circle'
                                                                    }
                                                                >
                                                                </div>
                                                                {selectedFeedbackReport.last_ai_confidence}
                                                            </td>
                                                        </tr>
                                                    }

                                                    {!selectedFeedbackReport &&
                                                        <tr className="trClassFormat">
                                                            <td colSpan={'6'}> No Data Selected</td>
                                                        </tr>
                                                    }

                                                    </tbody>
                                                </table>
                                            </div>
                                        </Col>
                                    </Row>
                                    <FeedbackReport
                                        initialValues={formData}
                                        labelManager={labelManager}
                                        onSubmit={this.handleCreate}
                                        onCancel={this.closeForm}
                                    />
                                </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row className="field report-graph-block">
                    <Col lg={6} xs={6} sm={6}>
                        <div className="white-bg">
                            <div className="title-details">
                                <div className="col-lg-12 ">
                                   <h4>Event Severity History with Newness (Measure of AI Model Drift) </h4>
                                </div>
                            </div>
                            <div className="pro top-m" >
                                {historyLoaded ?
                                    <LineChart
                                        width={500}
                                        height={300}
                                        data={historyReport.history}
                                        margin={{
                                            top: 5, right: 5, left: 10, bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid  />
                                        <XAxis label={<AxisLabel axisType='xAxis' x={250} y={290} width={0} height={0} >Timeline</AxisLabel>} dataKey='end_data_time'   tickFormatter={this.formatTimeline}/>
                                        <YAxis label={<AxisLabel axisType='yAxis' x={30} y={130} width={0} height={0}>Severity</AxisLabel>} type='number' domain={[0,8]} orientation='left' yAxisId={0} />
                                        <YAxis label={<AxisLabel axisType='yAxis' x={500} y={130} width={0} height={0}>Newness</AxisLabel>} type='number' domain={[0,3]} orientation='right' yAxisId={1} />
                                        <Tooltip content ={<this.customTooltip />} />
                                        <Legend payload={event_payload} iconSize={15}  layout="horizontal" verticalAlign="top" align="center" wrapperStyle={style} />
                                        <Line type="monotone"  name={"Severity "} dataKey="severity_numval" stroke={rulColor} dot={false} yAxisId={0} activeDot={{ r: 8, onClick:this.loadEventChartImage }} />
                                        <Line type="monotone"  name={"Newness "} dataKey="newness" stroke={newnessColor} dot={false} yAxisId={1} activeDot={{ r: 8, onClick:this.loadEventChartImage }} />
                                    </LineChart>
                                :(this.LoadingHistory())
                                }
                            </div>
                        </div>
                    </Col>

                    <Col lg={6} xs={6} sm={6}>
                        <div className="white-bg">
                            <div className="title-details">
                                <div className="col-lg-12 col-sm-12 col-xs-12">
                                    <h4>Visualization of features at a point on Event chart</h4>
                                </div>
                            </div>
                            <div className="pro top-m" >
                                { featureImageLoading ? (this.LoadingImage()) :(
                                    <img src={featureImage} />

                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }
}


EditFeedbackReport.propTypes = {
    t: PropTypes.func.isRequired,
};

function mapStateToProps({eventManagement, reports, feedback}) {
    return {
        selectedFeedbackReport : eventManagement.selectedEvent,
        featureImageLoading: reports.featureImageLoading,
        featureImage: reports.featureImage,
        historyReport: eventManagement.historyReport,
        labelManager:feedback.labelManager
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadEventHistory,
            loadFeatureImage,
            createEventFeedback
        },
        dispatch
    );
}

export default withTranslation('common') (
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(EditFeedbackReport)
);
